// The Messages push card's "Not now" history, kept per browser. Push is
// per browser anyway, so a per-browser back-off is the right scope; it's a
// convenience, so an unreadable or blocked store just means "never dismissed".

import { z } from 'zod';

import { readStorage, writeStorage } from '../browser-storage';
import type { PromptDismissals } from './push-state';

const STORAGE_KEY = 'leanin.push.promptDismissals';

const StoredDismissals = z.object({
  count: z.number().int().nonnegative(),
  lastDismissedAt: z.number().nonnegative(),
});

export function readPromptDismissals(): PromptDismissals | null {
  const raw = readStorage('local', STORAGE_KEY);
  if (raw === null) return null;
  let json: unknown;
  try {
    json = JSON.parse(raw);
  } catch (err) {
    // A value someone else wrote under our key: treat it as no history.
    if (err instanceof SyntaxError) return null;
    throw err;
  }
  const parsed = StoredDismissals.safeParse(json);
  return parsed.success ? parsed.data : null;
}

/** Returns whether the history was persisted. Unpersisted, the card still
 *  hides for this page view; it just comes back on the next load. */
export function writePromptDismissals(dismissals: PromptDismissals): boolean {
  return writeStorage('local', STORAGE_KEY, JSON.stringify(dismissals));
}
